<template>
  <v-container fluid fill-height class="pa-0" style="max-height: 100vh">
    <v-layout row wrap>
      <v-flex xs12>
        <browser-alert></browser-alert>
      </v-flex>
      <v-layout fill-height row>
        <v-img class="hidden-sm-and-down" :src="background"></v-img>
        <v-flex
          xs12
          md6
          lg4
          xl4
          class="overflow--auto"
          :class="highContrast ? 'dark' : 'white'"
        >
          <v-layout column fill-height>
            <v-toolbar
              class="elevation-0"
              :color="highContrast ? 'dark' : 'primary'"
            >
              <v-layout align-center justify-center row>
                <accessibility></accessibility>
              </v-layout>
            </v-toolbar>
            <v-layout align-center justify-center>
              <v-flex style="max-width: 414px" class="pa-3">
                <v-layout
                  column
                  class="text-xs-center"
                  :class="{ loading: loading }"
                >
                  <v-img
                    contain
                    class="text-xs-center mb-4"
                    height="65"
                    :src="logoOperadora"
                  ></v-img>
                  <router-view
                    :high-contrast="highContrast"
                    :unimeds="unimeds"
                    @login="onLogin"
                    @primeiro-acesso="onPrimeiroAcesso"
                  ></router-view>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-footer
              height="64"
              class="px-5 pb-2"
              :color="highContrast ? 'dark' : 'white'"
            >
              <v-img
                contain
                class="text-xs-center h-logo"
                height="57"
                :src="logoPortal"
              ></v-img>
            </v-footer>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
    <lgpd-modal
      :show.sync="showLGPDModal"
      :show-loading.sync="showLoading"
      @download-terms="termsDownload"
      @download-policy="policyDownload"
      @confirm="lgpdResolve"
      @cancel="lgpdReject"
    />
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import Background from "@/assets/fundo-login.png";
import BackgroundContrast from "@/assets/fundo-login-hc.png";
import ZitrusLogo from "@/assets/logo_zitrus.png";
import ZitrusLogoContrast from "@/assets/logo_zitrus_branco.png";
import OperadoraLogo from "@/assets/unimed-logo-1.png";
import OperadoraLogoContrast from "@/assets/unimed-logo-1-hc.png";

import Accessibility from "@/components/Accessibility";
import BrowserAlert from "@/components/BrowserAlert";

import { unimeds } from "@/services/usuario";

const { mapState } = createNamespacedHelpers("portal");

import LgpdModal from "@unimed/unijs/lgpdModal";

import auth from "./auth";

export default {
  name: "Layout",
  components: {
    Accessibility,
    BrowserAlert,
    LgpdModal
  },
  props: {
    product: String
  },
  computed: {
    ...mapState(["highContrast", "loading"]),
    background() {
      return this.highContrast
        ? this.backgroundContrast
        : this.backgroundDefault;
    },
    logoPortal() {
      return this.highContrast
        ? this.logoPortalContrast
        : this.logoPortalDefault;
    },
    logoOperadora() {
      return this.highContrast
        ? this.logoOperadoraContrast
        : this.logoOperadoraDefault;
    }
  },
  data() {
    return {
      unimeds: [],
      backgroundDefault: Background,
      backgroundContrast: BackgroundContrast,
      logoPortalDefault: ZitrusLogo,
      logoPortalContrast: ZitrusLogoContrast,
      logoOperadoraDefault: OperadoraLogo,
      logoOperadoraContrast: OperadoraLogoContrast,
      showLGPDModal: null,
      showLoading: null,
      termsDownload: () => {},
      policyDownload: () => {},
      lgpdResolve: () => {},
      lgpdReject: () => {}
    };
  },
  created() {
    this.carregaUnimeds();
    this.$vuetify.theme = {
      primary: "#00995D",
      secondary: "#b1d34b",
      accent: "#ECECEC",
      dark: "#424242",
      error: "#ff5252",
      warning: "#F47920"
    };
  },
  methods: {
    carregaUnimeds() {
      unimeds().then(response => {
        this.unimeds = response;
      });
    },
    onLogin(params) {
      auth.login
        .apply(this, [params, this.$store, this.$router, this.product])
        .then(
          () => {},
          error => {
            let error_description = null;
            if (error === "User credentials have expired") {
              error_description = "As credenciais de usuário expiraram";
              this.$router.push({
                name: "acesso-expirado",
                params: { username: params.username }
              });
            }
            if (error === "User is disabled") {
              error_description = "Seu usuário está inativo";
              this.$router.push({
                name: "acesso-inativo",
                params: { username: params.username }
              });
            }

            this.$store.commit("portal/setToast", error_description || error);
          }
        );
    },
    onPrimeiroAcesso(params) {
      auth.primeiroAcesso.apply(this, [params, this.$store, this.$router]);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/loading.scss";

html {
  overflow: hidden;
}
.h-logo {
  margin-bottom: 30px;
}
</style>
